import { HTMLAttributes, useRef } from 'react'
import { Transition } from 'react-transition-group'
import { useGSAP } from '@gsap/react'
import gsap from 'gsap'

import { MaskColumns, useTransitionStore } from '@/contexts/transition'
import { useLoaderStore } from '@/store/loader'

import { cn } from '@/lib/utils'

export type LoaderProps = HTMLAttributes<HTMLDivElement>

const Loader = ({ className, ...props }: LoaderProps) => {
  const nodeRef = useRef<HTMLDivElement>(null)
  const { contextSafe } = useGSAP({ scope: nodeRef })
  const loaded = useLoaderStore((state) => state.loaded)
  const setLoaderState = useLoaderStore((state) => state.setState)
  const setTransitionState = useTransitionStore((state) => state.setState)

  const createTimeline = contextSafe(() =>
    gsap
      .timeline()
      .to('[data-mask-accent]', { opacity: 0, duration: 1, ease: 'power2.out' })
      .to(
        ['[data-mask-l-white]', '[data-mask-r-white]'],
        { scaleY: 0, transformOrigin: 'top', duration: 1, ease: 'power3.out', stagger: 0.12 },
        0
      )
      .to('[data-mask-transparent]', { yPercent: -100, duration: 1, ease: 'power3.out' }, 0)
      .to('[data-mask-loader]', { yPercent: 100, duration: 1, ease: 'power3.out' }, 0)
  )

  const handleEndListener = contextSafe(async (done: () => void) => {
    setTransitionState({ active: true })
    gsap.delayedCall(0.2, () => setTransitionState({ landing: true }))
    await createTimeline()
    setTransitionState({ active: false, landing: false })
    setLoaderState({ loading: false })
    done()
  })

  return (
    <Transition nodeRef={nodeRef} in={!loaded} addEndListener={handleEndListener} unmountOnExit>
      <MaskColumns
        ref={nodeRef}
        className={cn('fixed left-0 top-0 z-loader h-full w-full', className)}
        {...props}
      />

      {/* <div
        ref={nodeRef}
        className={cn('fixed left-0 top-0 z-loader h-full w-full', className)}
        {...props}
      >
        <div
          className="absolute left-0 top-0 h-full w-full bg-surface-accent-light"
          data-mask-accent
        />
        <div
          className="absolute left-0 top-0 h-full w-[calc(50%+0.1rem)] bg-white-light"
          data-mask-l-white
        />
        <div
          className="absolute right-0 top-0 h-full w-[calc(50%+0.1rem)] bg-white-light"
          data-mask-r-white
        />
        <div className="absolute left-0 top-0 h-full w-full overflow-clip" data-mask-transparent>
          <div
            className="h-dvh-vh relative flex w-full items-center justify-center"
            data-mask-loader
          >
            <Logo className="text-text-accent-light" loop />
          </div>
        </div>
      </div> */}
    </Transition>
  )
}

export default Loader
